import React, { Fragment } from 'react'
import { usePutAway } from '../../Context/usePutAway'
import { DescriptionPutAway } from '../DescriptionPutAway/DescriptionPutAway'
import { DocsMatchPutAway } from '../DocsMatchPutAway/DocsMatchPutAway'
import { SearchPutAway } from '../SearchPutAway/SearchPutAway'
import LocateHistoryPutAway from '../LocateHistoryPutAway/LocateHistoryPutAway'
import { stepperTypes } from '../../types/stepperTypes'
import { UnknowOt } from '../UnknowOt/UnknowOt'
import { LPNSelectionPutAway } from '../LPNSelectionPutAway/LPNSelectionPutAway'

export const StepperPutAway = () => {
  const { state } = usePutAway()
  const { step } = state

  const {
    stepSearchPutAway,
    stepDocsMatchPutAway,
    stepDescriptionPutAway,
    stepLocateHistoryPutAway,
    stepUnknowOt,
    stepLPNSelection
  } = stepperTypes

  return (
    <Fragment>
      {step === stepSearchPutAway && <SearchPutAway />}
      {step === stepDocsMatchPutAway && <DocsMatchPutAway />}
      {step === stepDescriptionPutAway && <DescriptionPutAway />}
      {step === stepLocateHistoryPutAway && <LocateHistoryPutAway />}
      {step === stepUnknowOt && <UnknowOt />}
      {step === stepLPNSelection && <LPNSelectionPutAway />}
    </Fragment>
  )
}
